<template>
  <v-list-item v-on="rowClickEnabled && item.rowClick ? { click: item.rowClick } : {}"
               class="corporation-list-item">
    <v-list-item-content :class="{ 'deleted' : item.corporation.deleted}">
      <v-list-item-title>
        <span class="corporation-name">{{ item.corporation.name }}</span>
        <span v-if="item.corporation.deleted"
            class="deleted-marker ml-3">{{ $t('entityTable.deletedItem') }}</span>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action v-if="showActions && !!item.rowActions && !!item.rowActions.length > 0">
      <entity-table-row-end-action-menu :actions="item.rowActions"/>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import EntityTableRowEndActionMenu from '@/components/entity-crud/EntityTableRowEndActionMenu';

export default {
  name: 'CorporationListItem',
  components: { EntityTableRowEndActionMenu },
  props: {
    item: {
      type: Object,
      required: true,
      validator: item => {
        return !!item.corporation;
      },
    },
    showActions: {
      type: Boolean,
    },
    rowClickEnabled: {
      type: Boolean,
    },
  },
};
</script>

<style>
.corporation-list-item .deleted .corporation-name,
.corporation-list-item .deleted .deleted-marker{
  color:red !important;
}

</style>
